<template>
    <listMindsetsComponent />
</template>

<script>
import listMindsetsComponent from "@/views/mindset/pages/list_mindsets/components/list_mindsets_component.vue"
export default {
    name: "mindsets",
    components: {
        listMindsetsComponent
    },
}
</script>

<style lang="css" scoped>
</style>